import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { Building2 as g, Users as v, Target as u, Pencil as x } from "lucide-react";
import { forwardRef as y } from "react";
import { A as L } from "./Avatar-ihLwDM5D.js";
import { B as C } from "./Button-icgr8OM9.js";
import { C as c } from "./Card-BpiP0p3P.js";
import { P as d } from "./Pill-uAcQLotY.js";
import { S as t } from "./Skeleton-BOboktJd.js";
import { c as p } from "./cn-DlLpp5ix.js";
function E(n, a) {
  return a && a.length > 0 ? a.slice(0, 3).toUpperCase() : typeof n != "string" ? "" : n.trim().split(/\s+/).slice(0, 2).map((r) => r[0] ?? "").join("").toUpperCase();
}
const w = {
  display: "flex",
  alignItems: "flex-start",
  gap: "var(--space-3)",
  width: "100%"
}, S = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-1)",
  flex: 1,
  minWidth: 0
}, _ = {
  fontFamily: "var(--font-sans)",
  fontSize: "var(--text-md)",
  fontWeight: 700,
  color: "var(--text-primary)",
  lineHeight: "var(--line-md)",
  letterSpacing: "var(--tracking-snug)",
  margin: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, T = {
  fontSize: "var(--text-sm)",
  color: "var(--text-secondary)",
  lineHeight: "var(--line-sm)",
  margin: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical"
}, A = {
  fontSize: "var(--text-xs)",
  color: "var(--text-tertiary)",
  lineHeight: "var(--line-xs)",
  display: "flex",
  flexWrap: "wrap",
  alignItems: "baseline",
  gap: "var(--space-1)",
  margin: 0
}, O = {
  color: "var(--text-secondary)",
  fontWeight: 500
}, B = {
  display: "flex",
  alignItems: "center",
  gap: "var(--space-2)",
  flexWrap: "wrap",
  marginTop: "var(--space-2)"
}, b = {
  display: "flex",
  alignItems: "flex-start",
  flexShrink: 0
}, P = y(function({ business: a, onEdit: l, copy: r, className: h }, f) {
  const s = E(a.name, a.initials), o = `ls-business-card-${a.id}`, m = r.accountAriaLabel?.(a.account);
  return /* @__PURE__ */ e(c, { ref: f, asChild: !0, padding: "lg", radius: "2xl", className: p("ls-business-card", h), children: /* @__PURE__ */ e("article", { "aria-labelledby": o, "data-ls-composite": "business-card", "data-id": a.id, children: /* @__PURE__ */ i("div", { style: w, children: [
    /* @__PURE__ */ e(
      L,
      {
        size: "lg",
        tone: a.identityColor ? "identity" : "accent",
        identityColor: a.identityColor,
        initials: s,
        alt: typeof a.name == "string" ? a.name : s || "Business"
      }
    ),
    /* @__PURE__ */ i("div", { style: S, children: [
      /* @__PURE__ */ e("h3", { id: o, style: _, "data-ls-business-name": !0, children: a.name }),
      /* @__PURE__ */ e("p", { style: T, "data-ls-business-offer": !0, children: a.offer }),
      a.valueProp ? /* @__PURE__ */ i("p", { style: A, "data-ls-business-value-prop": !0, children: [
        /* @__PURE__ */ e("span", { children: r.valuePropLabel }),
        /* @__PURE__ */ e("span", { style: O, children: a.valueProp })
      ] }) : null,
      /* @__PURE__ */ i("div", { style: B, children: [
        /* @__PURE__ */ e(
          d,
          {
            tone: "neutral",
            variant: "soft",
            size: "sm",
            icon: /* @__PURE__ */ e(v, { "aria-hidden": "true", size: 12 }),
            "aria-label": m,
            "data-ls-business-account": !0,
            children: a.account
          }
        ),
        /* @__PURE__ */ e(
          d,
          {
            tone: "accent",
            variant: "soft",
            size: "sm",
            icon: /* @__PURE__ */ e(u, { "aria-hidden": "true", size: 12 }),
            "data-ls-business-campaigns": !0,
            "data-count": a.campaignCount,
            children: r.campaignsChip(a.campaignCount)
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e("div", { style: b, children: /* @__PURE__ */ e(
      C,
      {
        variant: "ghost",
        size: "sm",
        iconLeft: /* @__PURE__ */ e(x, { "aria-hidden": "true", size: 12 }),
        onClick: () => l(a.id),
        "data-ls-business-edit": !0,
        children: r.editLabel
      }
    ) })
  ] }) }) });
});
P.displayName = "BusinessCard";
const z = "Loading business";
function F({
  className: n,
  "aria-label": a = z
}) {
  return /* @__PURE__ */ e(c, { padding: "lg", radius: "2xl", className: p("ls-business-card-skeleton", n), children: /* @__PURE__ */ i(
    "div",
    {
      role: "status",
      "aria-label": a,
      "aria-busy": "true",
      style: { display: "flex", alignItems: "flex-start", gap: "var(--space-3)" },
      children: [
        /* @__PURE__ */ e(t, { variant: "circle", width: 40, height: 40, "aria-hidden": "true" }),
        /* @__PURE__ */ i("div", { style: { flex: 1, display: "flex", flexDirection: "column", gap: "var(--space-2)" }, children: [
          /* @__PURE__ */ e(t, { variant: "text", width: "40%", height: 14 }),
          /* @__PURE__ */ e(t, { variant: "text", width: "80%", height: 12 }),
          /* @__PURE__ */ e(t, { variant: "text", width: "60%", height: 12 }),
          /* @__PURE__ */ i("div", { style: { display: "flex", gap: "var(--space-2)", marginTop: "var(--space-1)" }, children: [
            /* @__PURE__ */ e(t, { variant: "rect", width: 80, height: 20 }),
            /* @__PURE__ */ e(t, { variant: "rect", width: 100, height: 20 })
          ] })
        ] }),
        /* @__PURE__ */ e(t, { variant: "rect", width: 104, height: 28 })
      ]
    }
  ) });
}
const j = g;
export {
  P as B,
  j as D,
  F as a
};
//# sourceMappingURL=BusinessCard-B8jhPxsw.js.map
